import React from 'react';
import { SubMenu } from '../SubMenu/SubMenu';

function MaterialGroupView(): JSX.Element {
  return <SubMenu />;
}

export default MaterialGroupView;
